/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type DefaultMetaNewAlertEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  firstName: string | null
  lastName: string | null
}

export type DefaultMetaNewAlertVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  inService: boolean | null
  label: number | null
}

export const DefaultMetaNewAlertEmployeeFragmentDoc = gql`
    fragment DefaultMetaNewAlertEmployee on Employee {
  ...DriverIconLinkEmployee
}
    `
export const DefaultMetaNewAlertVehicleFragmentDoc = gql`
    fragment DefaultMetaNewAlertVehicle on Vehicle {
  ...VehicleIconLinkVehicle
}
    `
